export default function AboutMethodProgramImage() {
    // Used in AboutMethod to display main content illustration

    // BUILD
    return (
        <div className={`mt-[24px] h-[120px] min-h-[120px] flex justify-center items-center`}>
            <img className={"object-contain h-full"}
                 src={'/images/aboutScreen/AboutMethodProgramIllustration.png'}
                 alt="Scientifique" />
        </div>
    );
}